import { VacancyCreate, VacancyBreadcrumbs } from '@features/vacancy';
import { PageContainer } from '@shared/ui';
import { useEffect } from 'react';
import { useBreadcrumbs } from '@shared/lib';
import { useNavigate } from 'react-router';

export const VacancyCreatePage = () => {
  const navigate = useNavigate();
  const context = useBreadcrumbs();

  const handleBackClick = () => {
    navigate('/vacancy-list');
  };

  useEffect(() => {
    if (!context) {
      return;
    }

    context.setBreadcrumb(<VacancyBreadcrumbs subPage='Новая вакансия' />);

    return () => {
      context.clearBreadcrumb();
    };
  }, []);

  return (
    <PageContainer title='Новая вакансия' py={{ base: 8, sm: 16 }} mx='0'>
      <VacancyCreate onBackClick={handleBackClick} />
    </PageContainer>
  );
};
